// src/pages/CookiePolicy.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FiShield, FiInfo, FiSettings, FiDatabase } from "react-icons/fi";
import "../styles/cookie-policy.css";

const CookiePolicy = () => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="cookie-policy-page">
      <div className="cookie-policy-container">
        <div className="cookie-policy-header">
          <FiShield className="cookie-policy-icon" />
          <h1>Cookie Policy</h1>
          <p>Last Updated: {currentDate}</p>
        </div>

        <div className="cookie-policy-content">
          <section>
            <h2>What Are Cookies?</h2>
            <p>
              Cookies are small text files that are placed on your computer or
              mobile device when you visit a website. They are widely used to
              make websites work more efficiently and provide information to the
              website owners.
            </p>
          </section>

          <section>
            <h2>How We Use Cookies</h2>
            <p>
              We use cookies to enhance your browsing experience, analyze site
              traffic, and personalize content. We respect your privacy and give
              you control over which cookies you accept.
            </p>
          </section>

          <section>
            <h2>Types of Cookies We Use</h2>

            <div className="cookie-type-card">
              <div className="cookie-type-header">
                <FiDatabase />
                <h3>Necessary Cookies</h3>
                <span className="cookie-badge">Always Active</span>
              </div>
              <p>
                These cookies are essential for the website to function
                properly. They enable core functionality such as security,
                shopping cart, and account access. You cannot disable these
                cookies.
              </p>
            </div>

            <div className="cookie-type-card">
              <div className="cookie-type-header">
                <FiSettings />
                <h3>Functional Cookies</h3>
              </div>
              <p>
                These cookies allow the website to remember choices you make and
                provide enhanced features, such as remembering your preferences
                or language settings.
              </p>
            </div>

            <div className="cookie-type-card">
              <div className="cookie-type-header">
                <FiInfo />
                <h3>Analytics Cookies</h3>
              </div>
              <p>
                When you opt in to Analytics, we record storefront pages viewed,
                a temporary visitor-session identifier, device and browser
                category, language and time zone, referring website domain, and
                campaign tags in links. The server also records the connection
                IP address and browser user-agent with these events. These
                details are used for store reporting and are not anonymous.
              </p>
            </div>

            <div className="cookie-type-card">
              <div className="cookie-type-header">
                <FiDatabase />
                <h3>Marketing Cookies</h3>
              </div>
              <p>
                These cookies track your online activity to help advertisers
                deliver more relevant advertising or to limit how many times you
                see an ad.
              </p>
            </div>
          </section>

          <section>
            <h2>How to Control Cookies</h2>
            <p>
              You can manage your cookie preferences at any time by clicking the
              cookie icon at the bottom of the page. You can also adjust your
              browser settings to block or delete cookies. However, please note
              that blocking some cookies may affect the functionality of our
              website.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              If you have any questions about our use of cookies, please contact
              us at{" "}
              <a href="mailto:privacy@tooraflex.co.za">
                privacy@tooraflex.co.za
              </a>
            </p>
          </section>

          <div className="cookie-policy-footer">
            <Link to="/" className="back-to-home">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
